import { useTranslation } from 'react-i18next'

import { ExternalLinkIcon } from '#/shared/ui/icons'

interface QuotePortalCellProps {
  href?: string
  onClick?: () => void
  label?: string
}

export function QuotePortalCell({
  href,
  onClick,
  label,
}: QuotePortalCellProps) {
  const { t } = useTranslation()
  const text = label ?? t('table.open')

  const content = (
    <span className="flex items-center gap-1.25 rounded border border-gray-200 px-1.25 py-0.75 text-sm text-primary hover:bg-gray-50">
      {text}
      <ExternalLinkIcon className="size-4 shrink-0" />
    </span>
  )

  return (
    <div className="flex flex-col items-start">
      <div className="flex h-7 items-center">
        {href ? (
          <a
            href={href}
            target="_blank"
            rel="noreferrer"
            className="cursor-pointer"
          >
            {content}
          </a>
        ) : (
          <button type="button" onClick={onClick} className="cursor-pointer">
            {content}
          </button>
        )}
      </div>
      <div className="h-7" />
    </div>
  )
}
